var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_555_5525)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.498 21.001H2.49801C2.10001 21.001 1.74001 20.765 1.58201 20.401C1.42201 20.036 1.49401 19.612 1.76601 19.321L4.07101 16.837C3.04001 15.393 2.49901 13.736 2.49901 12.001C2.49901 7.03798 6.98501 3.00098 12.499 3.00098C18.013 3.00098 22.499 7.03798 22.499 12.001C22.499 16.964 18.012 21.001 12.498 21.001ZM4.79101 19.001H12.498C16.909 19.001 20.498 15.861 20.498 12.001C20.498 8.14198 16.909 5.00098 12.498 5.00098C8.08701 5.00098 4.49801 8.14198 4.49801 12.001C4.49801 13.538 5.06601 15.001 6.14001 16.233C6.47601 16.619 6.46701 17.196 6.11901 17.571L4.79101 19.001Z",
    fill: "color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.49802 13.001C9.0503 13.001 9.49802 12.5533 9.49802 12.001C9.49802 11.4487 9.0503 11.001 8.49802 11.001C7.94573 11.001 7.49802 11.4487 7.49802 12.001C7.49802 12.5533 7.94573 13.001 8.49802 13.001Z",
    fill: "color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.498 13.001C13.0503 13.001 13.498 12.5533 13.498 12.001C13.498 11.4487 13.0503 11.001 12.498 11.001C11.9457 11.001 11.498 11.4487 11.498 12.001C11.498 12.5533 11.9457 13.001 12.498 13.001Z",
    fill: "color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.498 13.001C17.0503 13.001 17.498 12.5533 17.498 12.001C17.498 11.4487 17.0503 11.001 16.498 11.001C15.9457 11.001 15.498 11.4487 15.498 12.001C15.498 12.5533 15.9457 13.001 16.498 13.001Z",
    fill: "color"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_555_5525"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBubble);
export default __webpack_public_path__ + "static/media/chat-bubble.92e3d6cb298d39870d1e4c55f7026ab6.svg";
export { ForwardRef as ReactComponent };